import React from 'react';

import { Badge } from '../Badge';

interface Props {
  hasPromotionLabel?: boolean;
  hasNewLabel?: boolean;
}

export const ProductBadges = (props: Props) => {
  const { hasNewLabel, hasPromotionLabel } = props;
  return (
    <div className="flex gap-1">
      {hasPromotionLabel && <Badge textId="productBox.badge.promotion" color="red-400" />}
      {hasNewLabel && <Badge textId="productBox.badge.new" color="blue-700" />}
    </div>
  );
};
